<template>
    <div v-if="drivingTeams">
        <TeamDeliveries v-for="team in teams" :key="team" :fdID="this.fdID" :fdStatus="this.fdStatus" :teamName=team
            :drivingTeams="this.drivingTeams" :walkingTeams="this.walkingTeams">
        </TeamDeliveries>
    </div>
    <div v-else-if="allDeliveries">
        <h1 class="title is-5">Total Deliveries: {{ allDeliveries.length }}</h1>
        <DeliveryItem v-for="delivery in allDeliveries" :key="delivery.beneficiary_id" :name="delivery.full_name"
            :dryBag="delivery.dry_bag" :quantity="delivery.quantity" :unit="delivery.unit" :block="delivery.block"
            :street="delivery.street" :completed="delivery.completed" :completedAtTime="delivery.completed_at_time"
            :age="delivery.age" :deliverySort="delivery.delivery_sort" :beneficiaryID="delivery.beneficiary_id"
            :fdID="this.fdID" :fdStatus="this.fdStatus" :status="delivery.status" :selfCollection="delivery.self_collection"
            :drivingDelivery="delivery.driving_delivery" :deliveryNotes="delivery.notes" :drivingTeams="this.drivingTeams"
            :walkingTeams="this.walkingTeams" :bagStatus="delivery.bag_status" :consecutiveUndeliveredCount="delivery.consecutive_undelivered_count"
            :dietaryRequirement="delivery.dietary_requirement" :adminNotes="delivery.delivery_notes">
        </DeliveryItem>
    </div>
</template>

<script>
import TeamDeliveries from './TeamDeliveries.vue';
import DeliveryItem from './DeliveryItem.vue';

export default {
    components: {
        TeamDeliveries,
        DeliveryItem
    },
    created() {
        this.loadAllDeliveries();
    },
    methods: {
        async loadAllDeliveries() {
            if (!this.allDeliveries) {
                this.$store.dispatch('delivery/getAllDeliveries', this.fdID);
            }
        }
    },
    props: ['fdID', 'fdStatus', 'drivingTeams', 'walkingTeams'],
    computed: {
        teams() {
            const teams = [];
            for (var i = 1; i <= this.drivingTeams; i++) {
                teams.push("driving" + i);
            }
            for (i = 1; i <= this.walkingTeams; i++) {
                teams.push("walking" + i);
            }
            return teams;
        },
        allDeliveries() {
            return this.$store.getters['delivery/getAllDeliveries'];
        }
    }
}
</script>